export enum LanguageEnum {
    DE = "de-CH",
    EN = "en-GB",
}

/**
 * localStorage key under which the user's chosen UI language is persisted.
 * Shared between `TranslatorService` and `LanguageInterceptor`.
 */
export const LANGUAGE_STORAGE_KEY = 'language';

